const API_BASE_URL = 'https://api.stmtcmarathahalli.com';
//const API_BASE_URL = 'http://localhost:9090';

export default API_BASE_URL;